<template>
  <div>
    <div class="modal-header">
      <h2>Izmena tiketa</h2>
    </div>
    <div class="ticket-edit">
      <h3 class="label-privacy">Privatnost</h3>
      <div class="radio-group">
        <input
          type="radio"
          id="private"
          name="privacy"
          value="1"
          v-model="ticket.privacy"
        />
        <label for="private">Privatan</label>
        <input
          type="radio"
          id="public"
          name="privacy"
          value="0"
          v-model="ticket.privacy"
        />
        <label for="public">Javni</label>
      </div>

      <h3>Status</h3>
      <div class="radio-group">
        <input
          type="radio"
          id="opened"
          name="status"
          value="Otvoren"
          v-model="ticket.current_status"
        />
        <label for="opened">Otvoren</label>
        <input
          type="radio"
          id="in-progress"
          name="status"
          value="U toku"
          v-model="ticket.current_status"
        />
        <label for="in-progress">U toku</label>
        <input
          type="radio"
          id="closed"
          name="status"
          value="Zatvoren"
          v-model="ticket.current_status"
        />
        <label for="closed">Zatvoren</label>
      </div>

      <h3>Prioritet</h3>
      <div class="radio-group">
        <input
          type="radio"
          id="low"
          name="priority"
          value="Nizak"
          v-model="ticket.priority_id"
        />
        <label for="low">Nizak</label>
        <input
          type="radio"
          id="medium"
          name="priority"
          value="Srednji"
          v-model="ticket.priority_id"
        />
        <label for="medium">Srednji</label>
        <input
          type="radio"
          id="high"
          name="priority"
          value="Visok"
          v-model="ticket.priority_id"
        />
        <label for="high">Visok</label>
      </div>

      <label class="col-form-label col-form-label-lg">Naslov</label>
      <input
        v-model="ticket.title"
        class="form-control form-control-lg"
        placeholder="Unesite naslov"
        @focus="errorOccurred = false"
      />
      <div class="section">
        <div class="desc-area">
          <label class="col-form-label col-form-label-lg label-desc"
            >Opis</label
          >
          <textarea
            v-model="ticket.description"
            class="form-control"
            rows="5"
            id="comment"
            placeholder="Unesite opis"
            @focus="errorOccurred = false"
            ref="descriptionArea"
          ></textarea>
        </div>
        <div class="upload-area">
          <label class="col-form-label col-form-label-lg label-desc"
            >Datoteke</label
          >
          <upload-button
            @files-selected="getFiles"
            :showLabel="false"
            ref="uploadBtn"
          ></upload-button>
          <div
            class="uploaded-files"
            :class="{ 'pointer-cursor': files.length == 0 }"
            @click="addFile"
            @dragover.prevent
            @dragleave.prevent
            @drop="onDrop"
          >
            <div class="upload-wrapper" v-if="files.length == 0">
              <svg
                class="upload-icon pointer-cursor"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="33"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <label class="upload-text pointer-cursor"
                >Izaberite datoteku</label
              >
            </div>
            <div class="file" v-for="(file, index) of files" :key="index">
              <p>{{ file.name }}</p>
              <i
                class="fas fa-times del--mod"
                @click="removeUploadedFile(index, $event)"
              ></i>
            </div>
            <div
              class="upload-more-wrapper pointer-cursor"
              @click="addMoreFiles"
              v-if="files.length > 0"
            >
              <svg
                class="upload-more-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <span class="upload-more-text">Dodaj datoteku</span>
            </div>
          </div>
        </div>
      </div>

      <label class="col-form-label col-form-label-lg heading">
        Infrastruktura
      </label>
      <model-select
        ref="municipality"
        :options="infrastructures"
        v-model="selectedInfrastructure"
        placeholder="
            Izaberite infrastrukturu"
        class="muni-dropdown add-member-dropdown"
        @input="onInfraChange"
      ></model-select>
      <label class="col-form-label col-form-label-lg heading">
        Serviser
      </label>
      <model-select
        ref="municipality"
        :options="contractors"
        v-model="selectedContractor"
        placeholder="
            Izaberite servisera"
        class="muni-dropdown add-member-dropdown"
        @input="onContractorChange"
      ></model-select>
      <p v-if="recomendedContractors.length != 0">
        <span v-if="recomendedContractors.length > 1">Predloženi </span>
        <span v-else>Predložen </span>
        <span v-if="recomendedContractors.length > 1">serviseri: </span>
        <span v-else>serviser:</span>
        <span v-for="(contractor, index) in recomendedContractors" :key="index">
          <span
            class="recomended-contractor"
            @click="selectRecomendedContractor(contractor)"
            >{{ contractor.text }}</span
          >
        </span>
      </p>
      <label class="col-form-label col-form-label-lg heading">
        Kontakt osoba
      </label>
      <model-select
        ref="municipality"
        :options="contractorContacts"
        v-model="selectedContact"
        placeholder="
            Izaberite kontakt osobu"
        class="muni-dropdown add-member-dropdown"
      ></model-select>
    </div>

    <div class="modal-footer">
      <hr />
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button class="btn btn-danger btn--mod" @click="closeThisModal">
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="submitMedia"
          :disabled="loading"
        >
          <span v-if="!loading">Pošalji</span>
          <spinner line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import axios from '@/axios/axios';
import { ModelSelect } from 'vue-search-select';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';

export default {
  components: {
    ModelSelect,
    uploadButton
  },
  data() {
    return {
      status: 1,
      ticketBeforeEdit: null,
      errorOccurred: false,
      errorMessage: '',
      contractors: [],
      selectedContractor: null,
      contractorContacts: [],
      selectedContact: null,
      infrastructures: [],
      selectedInfrastructure: null,
      recomendedContractors: [],
      allContacts: [],
      files: [],
      filesChanged: false,
      ticket: {}
    };
  },
  computed: {
    ...mapState('modal', ['modalVisible']),
    ...mapState(['loading'])
  },
  async created() {
    Object.assign(this.ticket, this.$store.state.modal.ticket);
    this.ticketBeforeEdit = {
      oldPrivacy: this.ticket.privacy,
      oldPriorityId: this.ticket.priority_id,
      oldCurrentStatus: this.ticket.current_status,
      title: this.ticket.title,
      description: this.ticket.description
    };
    if (this.ticket.community_infrastructure) {
      this.ticketBeforeEdit.community_infrastructure = this.ticket.community_infrastructure.id;
    } else {
      this.ticketBeforeEdit.community_infrastructure = null;
    }
    if (this.ticket.contractor) {
      this.ticketBeforeEdit.contractor = this.ticket.contractor.id;
    } else {
      this.ticketBeforeEdit.contractor = null;
    }
    if (this.ticket.contact) {
      this.ticketBeforeEdit.contact = this.ticket.contact.id;
    } else {
      this.ticketBeforeEdit.contact = null;
    }
    const contractorsResult = await this.getAllContractors(false);
    this.contractors = contractorsResult.map(cat => {
      cat.value = cat;
      cat.text = cat.name;
      return {
        value: cat,
        text: cat.name
      };
    });
    const response = await axios.get(
      `/community/${
        this.$store.getters.getActiveCommunity.id
      }/infrastructures-with-contractors`
    );
    this.infrastructures = response.data.data.map(infra => {
      infra.value = infra;
      infra.text = infra.name;
      return {
        value: infra,
        text: infra.name
      };
    });
    if (
      this.ticket.community_infrastructure &&
      this.ticket.community_infrastructure.id
    ) {
      const infra = this.infrastructures.filter(
        i => i.value.id == this.ticket.community_infrastructure.id
      );
      if (infra) {
        this.selectedInfrastructure = infra[0];
      }
    }
    if (this.ticket.contractor && this.ticket.contractor.id) {
      const contractor = this.contractors.filter(
        c => c.value.id == this.ticket.contractor.id
      );
      if (contractor) {
        this.selectedContractor = contractor[0];
        const result = await axios.get(
          `/contractor/${this.ticket.contractor.id}`
        );
        this.allContacts = result.data.contractor.contacts;
        this.contractorContacts = result.data.contractor.contacts.map(con => {
          return {
            text: `${con.name} (${con.phone})`,
            value: con.id
          };
        });
        if (this.ticket.contact) {
          const contact = this.contractorContacts.filter(
            c => c.value == this.ticket.contact.id
          );
          if (contact) {
            this.selectedContact = contact[0];
          }
        }
      }
    }
    if (this.ticket.media) {
      this.files = this.ticket.media.map(f => {
        f.name = f.file_name;
        return f;
      });
    }
  },
  methods: {
    ...mapMutations('ticket', ['editTicket', 'updateTicket']),
    ...mapMutations('modal', ['closeModal', 'showModal', 'setTicket']),
    ...mapActions('table', [
      'getTicketsByCommunity',
      'getAllTickets',
      'getAllContractors'
    ]),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['setPostTitle']),
    ...mapActions('ticket', ['getTicketComments', 'getTicketDetails']),
    removeUploadedFile(index, e) {
      this.files.splice(index, 1);
      this.filesChanged = true;
      e.stopPropagation();
    },
    getFiles(load) {
      for (let l of load) {
        this.files.push(l);
      }
    },
    onDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files;
      this.files.push(...files);
    },
    addFile() {
      if (this.files.length > 0) {
        return;
      }
      if (this.removingFile) {
        this.removingFile = false;
        return;
      }
      this.filesChanged = true;
      this.$refs.uploadBtn.openFileSelect();
    },
    addMoreFiles() {
      this.filesChanged = true;
      this.$refs.uploadBtn.openFileSelect();
    },
    async onContractorChange() {
      try {
        if (
          this.selectedContractor &&
          (this.selectedContractor.id || this.selectedContractor.value.id)
        ) {
          let contractorId = null;
          if (this.selectedContractor.id) {
            contractorId = this.selectedContractor.id;
          } else {
            contractorId = this.selectedContractor.value.id;
          }
          const result = await axios.get(`/contractor/${contractorId}`);
          this.allContacts = result.data.contractor.contacts;
          this.contractorContacts = result.data.contractor.contacts.map(con => {
            return {
              text: `${con.name} (${con.phone})`,
              value: con.id
            };
          });
        } else {
          this.selectedContractor = null;
          this.selectedContact = null;
          this.allContacts = [];
          this.contractorContacts = [];
        }
      } catch (error) {
        this.selectedContractor = null;
        this.selectedContact = null;
        this.allContacts = [];
        this.contractorContacts = [];
      }
    },
    onInfraChange() {
      try {
        if (
          this.selectedInfrastructure.id ||
          this.selectedInfrastructure.value.id
        ) {
          this.recomendedContractors = [];
          let selctedInfra = null;
          if (this.selectedInfrastructure.id) {
            selctedInfra = this.selectedInfrastructure;
          } else {
            selctedInfra = this.selectedInfrastructure.value;
          }
          for (const [
            index,
            contractorId
          ] of selctedInfra.contractors.entries()) {
            const contractor = this.contractors.find(
              c => c.value.id == contractorId
            );
            if (contractor) {
              if (index == selctedInfra.contractors.length - 1) {
                this.recomendedContractors.push({
                  text: contractor.text,
                  value: contractor.value
                });
              } else {
                this.recomendedContractors.push({
                  text: contractor.text + ', ',
                  value: contractor.value
                });
              }
            }
          }
        } else {
          this.selectedInfrastructure = null;
          this.recomendedContractors = [];
        }
      } catch (error) {
        this.selectedInfrastructure = null;
        this.recomendedContractors = [];
      }
    },
    selectRecomendedContractor(contractor) {
      this.selectedContractor = contractor;
      this.onContractorChange();
    },
    closeThisModal() {
      if (this.$router.history.current.name === 'ticketDetails') {
        this.updateTicket(this.ticketBeforeEdit);
      }
      this.closeModal();
    },
    getStatus() {
      switch (this.ticket.current_status) {
        case 'Nov':
          return 1;
        case 'Otvoren':
          return 2;
        case 'U toku':
          return 3;
        case 'Zatvoren':
          return 4;
        case 'Obrisan':
          return 5;
      }
    },
    getPriority() {
      switch (this.ticket.priority_id) {
        case '1':
        case 'Nizak':
          return 1;
        case '2':
        case 'Srednji':
          return 2;
        case '3':
        case 'Visok':
          return 3;
      }
    },
    validateChangeOfTicket() {
      let contactId = null;
      if (this.selectedContact && this.selectedContact.value) {
        contactId = this.selectedContact.value;
      } else {
        contactId = this.selectedContact;
      }
      const communityInfrastructureId = this.selectedInfrastructure
        ? this.selectedInfrastructure.value.id
        : null;
      const contractorId = this.selectedContractor
        ? this.selectedContractor.value.id
        : null;
      const contractorContactId = contactId;
      if (
        this.ticket.privacy === this.ticketBeforeEdit.oldPrivacy &&
        this.ticket.current_status === this.ticketBeforeEdit.oldCurrentStatus &&
        this.ticket.priority_id === this.ticketBeforeEdit.oldPriorityId &&
        contractorContactId == this.ticketBeforeEdit.contact &&
        contractorId == this.ticketBeforeEdit.contractor &&
        communityInfrastructureId ==
          this.ticketBeforeEdit.community_infrastructure &&
        this.ticket.title == this.ticketBeforeEdit.title &&
        this.ticket.description == this.ticketBeforeEdit.description &&
        !this.filesChanged
      ) {
        return false;
      }

      return true;
    },
    formatMediaForSubmit(filesForSubmit) {
      let fd = new FormData();
      for (let i = 0; i < filesForSubmit.length; i++) {
        fd.append('files[]', filesForSubmit[i], filesForSubmit[i].name);
      }
      fd.append('type', 'community');
      fd.append(
        'community_id',
        this.$store.getters.getActiveCommunity.community_id
      );
      return fd;
    },
    submitMedia() {
      if (this.loading) {
        return;
      }

      //if user didn't change anything
      this.errorOccurred = false;
      if (!this.validateChangeOfTicket()) {
        this.errorMessage = 'Niste ništa izmenili';
        this.errorOccurred = true;
        return;
      }
      //if request is already sent, disabling button
      if (this.loading) {
        return;
      }
      this.loadingStarted();
      const filesForSubmit = this.files.filter(f => !f.id);
      const oldMediaIds = this.files.filter(f => f.id).map(f => f.id);
      if (filesForSubmit.length === 0) {
        this.editTicket(oldMediaIds);
        return;
      }

      axios
        .post('/media/add', this.formatMediaForSubmit(filesForSubmit), {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(({ data }) => {
          // this.ticket.mediaIds = data.ids;
          // merge new with old mediaIds
          const allMediaIds = oldMediaIds.concat(data.ids);
          this.editTicket(allMediaIds);
        })
        .catch(error => {
          this.loadingFinished();
          console.log(error);
          this.showFailModal();
        });
    },
    editTicket(mediaIds) {
      this.errorOccurred = false;
      if (!this.validateChangeOfTicket()) {
        this.errorMessage = 'Niste ništa izmenili';
        this.errorOccurred = true;
        return;
      }
      let memberId;
      if (this.$router.history.current.name === 'communityTickets') {
        memberId = this.$store.getters.getActiveCommunity.member_id;
      } else {
        memberId = this.$store.getters.getCommunities.filter(
          c => c.community_id == this.ticket.community_id
        )[0].member_id;
      }
      let contactId = null;
      if (this.selectedContact && this.selectedContact.value) {
        contactId = this.selectedContact.value;
      } else {
        contactId = this.selectedContact;
      }
      this.loadingStarted();

      let editRequest = {
        privacy: this.ticket.privacy,
        status: this.getStatus(),
        priority: this.getPriority(),
        manager_member_id: memberId,
        communityInfrastructureId: this.selectedInfrastructure
          ? this.selectedInfrastructure.value.id
          : null,
        contractorId: this.selectedContractor
          ? this.selectedContractor.value.id
          : null,
        contractorContactId: contactId,
        managerMemberId: this.$store.getters.getActiveCommunity.member_id,
        description: this.ticket.description,
        title: this.ticket.title,
        mediaIds: mediaIds.map(m => parseInt(m))
      };
      axios
        .put(`/tickets/${this.ticket.id}`, editRequest)
        .then(async ({ data }) => {
          if (this.$router.history.current.name === 'communityTickets') {
            this.getTicketsByCommunity({
              memberId: this.$store.getters.getActiveCommunity.member_id,
              communityId: this.$store.getters.getActiveCommunity.id
            });
            this.setTicket(this.ticket);
            this.loadingFinished();
            this.closeModal();
            this.showSuccessModal();
          } else if (this.$router.history.current.name === 'ticketDetails') {
            // const contact = this.allContacts.filter(c => c.id == contactId);
            // if (contact) {
            //   this.ticket.contact = contact[0];
            // }
            // if (this.selectedContractor) {
            //   this.ticket.contractor = this.selectedContractor.value;
            // } else {
            //   this.ticket.contractor = null;
            // }
            // if (this.selectedInfrastructure) {
            //   this.ticket.community_infrastructure = this.selectedInfrastructure.value;
            // } else {
            //   this.ticket.community_infrastructure = null;
            // }
            // // this.ticket.mediaIds = mediaIds
            await this.getTicketDetails();
            // this.setPostTitle(this.ticket.title);
            await this.getTicketComments();
            this.loadingFinished();
            this.closeModal();
            this.showSuccessModal();
          } else {
            this.getAllTickets();
            this.loadingFinished();
            this.closeModal();
            this.showSuccessModal();
          }
        })
        .catch(error => {
          console.log(error);
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped lang="scss">
.desc-area {
  width: 66%;
}

.section {
  display: inline-flex;
  width: 100%;
  height: 100%;
  .label-desc {
    padding-left: 0;
    padding-bottom: 9px;
    padding-top: 9px;
    text-align: left;
    cursor: default;
  }
}

.upload-area {
  display: block;
  margin-left: 9px;
  width: 34%;
  height: 100%;
}
.uploaded-files {
  border: 1px dotted var(--primary-color);
  border-radius: 0.25rem;
  height: 110px;
  resize: none;
  max-height: 134px;
  overflow-y: auto;
  padding: 5px;
}

.file {
  border-bottom: solid 1px lightgray;
  font-size: 15px;
  width: 100%;
  display: inline-flex;
  vertical-align: center;
  p {
    max-width: 100%;
    margin-bottom: 2px;
    word-break: break-all;
  }
}

.empty-files {
  text-align: center;
  color: grey;
  margin-top: 20%;
}

.del--mod {
  margin-left: auto;
  cursor: pointer;
  color: red;
  top: 4.7em;
  right: 1.7em;
}

textarea.form-control {
  resize: none;
  width: 100%;
  height: 110px;
}
.ticket-edit {
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  margin-top: 0.5rem;
  .label-privacy {
    margin-top: 0.5rem;
  }
}

.recomended-contractor {
  color: var(--primary-color);
  cursor: pointer;
}

input[type='radio'] {
  position: absolute;
  visibility: hidden;
  display: none;
}

label {
  color: var(--primary-color);
  display: inline-block;
  cursor: pointer;
  padding: 5px 20px;
  margin-bottom: 0;
  width: 9rem;
  text-align: center;
}

label.heading {
  width: auto;
}

input[type='radio']:checked + label {
  color: white;
  background: var(--primary-color);
}

label + input[type='radio'] + label {
  border-left: solid 1px var(--primary-color);
}
.radio-group {
  border: solid 1px var(--primary-color);
  display: inline-block;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  overflow: hidden;
}

.modal-footer {
  display: block;
  width: 100%;
  text-align: center;
}
.buttons {
  display: inline-flex;
  float: right;
}

.error {
  float: left;
  margin-left: 15px;
}

.err-msg {
  text-align: center;
  color: red;
}
</style>
